<template>
    <h1>Error occured!</h1>
</template>

<script type="text/babel">

export default {
    name: 'Error'
};

</script>

